import script from "./base-confirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-confirm.vue?vue&type=script&setup=true&lang=ts"

import "./base-confirm.vue?vue&type=style&index=0&id=3a148faa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a148faa"]])

export default __exports__